import api from "@/api";

export default {
    getAll(congTrinhId) {
        return api.get(`/api/cong-trinh/${congTrinhId}/hang-muc`);
    },
    
    // POST /api/api/cong-trinh/{id}/hang-muc
    create(congTrinhId, data) {
        return api.post(`/api/cong-trinh/${congTrinhId}/hang-muc`, data);
    },

    // PUT /api/api/cong-trinh/hang-muc/{id}
    update(hangMucId, data) {
        return api.put(`/api/cong-trinh/hang-muc/${hangMucId}`, data);
    },

    // DELETE /api/api/cong-trinh/hang-muc/{id}
    delete(hangMucId) {
        return api.delete(`/api/cong-trinh/hang-muc/${hangMucId}`);
    },
    capNhatTienDo (hangMucId, progress) {
return api.patch(`/api/cong-trinh/hang-muc/${hangMucId}/tien-do`, { progress });
    }
};